import React from "react";
import NavApp from "./NavApp";

export default function Nav() {
  return (
    <aside className="side">
      <NavApp />
    </aside>
  );
}
